import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import apiHelpers from '../../utils/apiHelpers';
import { CollectionProvider } from '../collection/CollectionContext';
import { WishlistProvider } from '../wishlist/WishlistContext';
import SideMenu from '../common/SideMenu';
import Footer from '../common/Footer';

const PrivateRoute = () => {
  if (!apiHelpers.isAuthenticated()) {
    // If not authenticated, redirect to login
    return <Navigate to="/login" />;
  }

  // If authenticated, render the layout with Outlet (children routes)
  const config = require('../../config/config');

  return (
    <CollectionProvider>
      <WishlistProvider>
        <div
          className={`flex flex-col min-h-screen ${
            config.showDonations ? 'pb-12' : ''
          }`}>
          <div className="flex flex-1 overflow-y-auto">
            <SideMenu />
            <div className="flex-1 overflow-y-auto ml-20 p-4">
              <Outlet />
            </div>
          </div>
          {config.showDonations && <Footer />}
        </div>
      </WishlistProvider>
    </CollectionProvider>
  );
};

export default PrivateRoute;
